"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _building = require("@/api/building.api");
var _building2 = require("@/types/building");
var _SingleImage = _interopRequireDefault(require("@/components/Upload/SingleImage.vue"));
var _BuildingApartment = _interopRequireDefault(require("./BuildingApartment.vue"));
var _BuildingStaff = _interopRequireDefault(require("./BuildingStaff.vue"));
var _CustomerFeedbackTab = _interopRequireDefault(require("./CustomerFeedbackTab.vue"));
var _BuildingService = _interopRequireDefault(require("./BuildingService.vue"));
var rule = {
  trigger: "submit",
  required: true,
  message: "Bắt buộc"
};
var BuildingModal = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(BuildingModal, _Vue);
  var _super = (0, _createSuper2.default)(BuildingModal);
  function BuildingModal() {
    var _this;
    (0, _classCallCheck2.default)(this, BuildingModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "visible", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "form", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "status", "create");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rules", {
      name: rule,
      address: rule,
      image: rule
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loading", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "tab", "");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "BuildingStatus", _building2.BuildingStatus);
    return _this;
  }
  (0, _createClass2.default)(BuildingModal, [{
    key: "onSubmitOk",
    value: function onSubmitOk() {
      return "";
    }
  }, {
    key: "changeStatus",
    value: function changeStatus(val) {
      debugger;
      if (!val) {
        this.form.status = _building2.BuildingStatus.Close;
      } else {
        this.form.status = _building2.BuildingStatus.Open;
      }
    }
  }, {
    key: "dataSubmit",
    get: function get() {
      return {
        building: (0, _objectSpread2.default)({}, this.form),
        images: this.form.image ? [this.form.image] : []
      };
    }
  }, {
    key: "setImage",
    value: function setImage(url) {
      this.$set(this.form, "image", url);
    }
  }, {
    key: "createData",
    value: function () {
      var _createData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$refs.form.validate();
              case 2:
                this.loading = true;
                _context.prev = 3;
                _context.next = 6;
                return _building.buildingApi.create(this.dataSubmit);
              case 6:
                this.$notify({
                  title: "Thông báo",
                  message: "Tạo mới thành công",
                  type: "success"
                });
                this.visible = false;
                this.onSubmitOk();
              case 9:
                _context.prev = 9;
                this.loading = false;
                return _context.finish(9);
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3,, 9, 12]]);
      }));
      function createData() {
        return _createData.apply(this, arguments);
      }
      return createData;
    }()
  }, {
    key: "deleteData",
    value: function () {
      var _deleteData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$confirm("Xác nhận xóa tòa nhà?", "Cảnh báo", {
                  confirmButtonText: "Xóa",
                  cancelButtonText: "Không",
                  type: "warning"
                });
              case 2:
                this.loading = true;
                _context2.prev = 3;
                _context2.next = 6;
                return _building.buildingApi.delete(this.form.id);
              case 6:
                this.$notify({
                  title: "Thông báo",
                  message: "Xóa thành công",
                  type: "success"
                });
                this.visible = false;
                this.onSubmitOk();
              case 9:
                _context2.prev = 9;
                this.loading = false;
                return _context2.finish(9);
              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3,, 9, 12]]);
      }));
      function deleteData() {
        return _deleteData.apply(this, arguments);
      }
      return deleteData;
    }()
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.$refs.form.validate();
              case 2:
                this.loading = true;
                _context3.prev = 3;
                _context3.next = 6;
                return _building.buildingApi.update(this.form.id, this.dataSubmit);
              case 6:
                this.$notify({
                  title: "Thông báo",
                  message: "Cập nhật thành công",
                  type: "success"
                });
                this.visible = false;
                this.onSubmitOk();
              case 9:
                _context3.prev = 9;
                this.loading = false;
                return _context3.finish(9);
              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3,, 9, 12]]);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.visible = true;
      this.status = "create";
      this.form = {
        status: _building2.BuildingStatus.Open
      };
      this.tab = "info";
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(data) {
      this.tab = "info";
      this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        image: data.buildingImages.length ? data.buildingImages[0].url : ""
      });
      this.visible = true;
      this.status = "update";
    }
  }]);
  return BuildingModal;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Emit)("submit:ok")], BuildingModal.prototype, "onSubmitOk", null);
BuildingModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    SingleImage: _SingleImage.default,
    BuildingStaff: _BuildingStaff.default,
    BuildingApartment: _BuildingApartment.default,
    CustomerFeedbackTab: _CustomerFeedbackTab.default,
    BuildingService: _BuildingService.default
  }
})], BuildingModal);
var _default = BuildingModal;
exports.default = _default;